import { css, createGlobalStyle } from 'styled-components';
import { AddressInputProps } from './models';
import pinIcon from '../../assets/pin.png';

export const AddressInput = css<AddressInputProps>(({ theme }) => {
  return css``;
});

export const GlobalStyle = createGlobalStyle`
  .pac-container {
    border-radius: 0 0 8px 8px;
    
    &:after {
      content: none;
    }

    > .pac-item {
      padding: 8px;
      height: 60px;
      border: none;


      > .pac-item-query {
        color: ${({ theme }) => theme?.colors.mediumGray};
        font-size: 16px;
        line-height: 21px;

        > .pac-matched {
          font-weight: 600;
          color: ${({ theme }) => theme?.colors.primaryBackground};
        }
      }

      > .pac-item-query + span {
        margin-left: 28px;
        display: block;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: ${({ theme }) => theme?.colors.placeholder2};

        > .pac-matched {
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;

          color: ${({ theme }) => theme?.colors.placeholder2};
        }
      }

      > .pac-icon.pac-icon-marker {
        background-image: url(${pinIcon}) !important;
        width: 16px;
        height: 20px;
        background-size: 16px 20px;
        background-repeat: no-repeat;
        margin: 4px 12px 0 0;
        background-position: 0;
      }

    }
  }

`;
